/** Константы модуля «Школы». */

// Мок / реальный бэкенд (как в остальных модулях: Health, DataUpdate).
export const USE_MOCK = true;

// Базовый путь API раздела.
export const SCHOOLS_API = '/api/schools';

// Начальное состояние фильтров-разрезов.
export const EMPTY_FILTERS = { shift: '', lang: '', status: '' };

// Цвета статуса (совпадают в таблице, столбчатой и третьей круговой диаграмме).
export const STATUS_COLOR = { good: '#57c15d', bad: '#e0605f', no_data: '#8b95a8' };

// Палитра КАТЕГОРИЙ (не оценка): контрастны по тону, не совпадают с зелёным/красным.
export const CATEGORY_COLORS = ['#4a90d9', '#a06fd6', '#3fa9b5', '#c78a3f'];

// Серый столбец «Проектная мощность».
export const CAP_COLOR = '#3a4456';

// Высота строки столбчатой диаграммы (секция растёт/прокручивается, столбцы не «сплющиваются»).
export const BAR_ROW_H = 34;
